jQuery(document).ready(function ($) {
  // Hide all accordion content initially
  $(".accordion-content").hide();

  // Report filters: open the compact groups (Types, Year, Technology) by
  // default so filtering is one click, not two. Vendor stays collapsed as
  // the list is too long to show open.
  $("#filter-form .checkboxes.accordion .accordion-content").show();
  $("#filter-form .checkboxes.accordion .accordion-header").addClass("expanded");

  // Event handler for accordion header click in the second accordion
  $(".accordion-header-menu").click(function (e) {
    e.preventDefault(); // Prevent default link behavior
    console.log("Clicked");
    // If not visible, toggle visibility of accordion content
    $(this).next(".accordion-content-menu").slideToggle();
    // Slide up all other accordion content
    $(".accordion-content-menu").not($(this).next()).slideUp();
    // Toggle 'expanded' class only for this accordion header
    $(this).toggleClass("expanded");
    // Remove 'expanded' class from headers in the first accordion
    $(".accordion-header-menu").removeClass("expanded");
  });

  // Event handler for accordion header click in the first accordion
  $(".accordion-header").click(function () {
    // Report filter groups toggle independently so users can keep
    // several groups open while combining filters
    if ($(this).closest("#filter-form").length) {
      $(this).next(".accordion-content").slideToggle();
      $(this).toggleClass("expanded");
      return;
    }
    // Toggle visibility of clicked header's content
    $(this).next(".accordion-content").slideToggle();
    // Slide up all other accordion content, leaving the filter groups alone
    $(".accordion-content")
      .not($(this).next())
      .not("#filter-form .accordion-content")
      .slideUp();
    // Toggle 'expanded' class only for this accordion header
    $(this).toggleClass("expanded");
    // Remove 'expanded' class from headers in the second accordion
    $(".accordion-header").removeClass("expanded");
  });

  // Check if the screen size is less than or equal to 768px (mobile)
});
